var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center",style:([
    {
      backgroundColor: '#F4F4F4',
      padding: `8px`,
      borderRadius: _vm.$getScaledCssValue('12px'),
      boxShadow: `0 ${_vm.$getScaledCssValue('3px')} ${_vm.$getScaledCssValue(
        '6px'
      )} #00000029`
    },
    _vm.$breakpoints.mdAndUp && {
      padding: `${_vm.$getScaledCssValue('17px')} ${_vm.$getScaledCssValue('25px')}`
    }
  ])},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.innerValue),expression:"innerValue"}],class:{
      'flex-grow-1 no-input-border': true,
      'text-p5': _vm.$breakpoints.smAndDown,
      'text-p3': _vm.$breakpoints.mdAndUp
    },staticStyle:{"outline":"none"},style:({ minWidth: 0 }),attrs:{"data-cy":"list-section-search-input","placeholder":_vm.$t('enterSearchTermMsg')},domProps:{"value":(_vm.innerValue)},on:{"input":function($event){if($event.target.composing)return;_vm.innerValue=$event.target.value}}}),_c('v-icon',{attrs:{"large":"","color":"gray darken-2"},on:{"click":_vm.handleUndoClick}},[_vm._v("mdi-refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }